import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import ScrollToTop from "../../components/feature/ScrollToTop";

export default function AvisoLegal() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://vpb-barcelona.com';

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Aviso Legal - Vaciado de Pisos Barcelona VPB",
    "description": "Aviso legal de Vaciado de Pisos Barcelona. Información sobre datos identificativos, condiciones de uso, propiedad intelectual y responsabilidad.",
    "url": `${siteUrl}/aviso-legal`,
    "inLanguage": "es-ES",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Vaciado de Pisos Barcelona VPB",
      "url": siteUrl
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Inicio",
        "item": siteUrl
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Aviso Legal",
        "item": `${siteUrl}/aviso-legal`
      }
    ]
  };

  return (
    <>
      <title>Aviso Legal - Vaciado de Pisos Barcelona VPB</title>
      <meta name="description" content="Aviso legal de Vaciado de Pisos Barcelona. Información sobre datos identificativos, condiciones de uso, propiedad intelectual y responsabilidad del sitio web." />
      <meta name="robots" content="noindex, follow" />
      <link rel="canonical" href={`${siteUrl}/aviso-legal`} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />

      <div className="min-h-screen bg-white">
        <Navbar />
        <ScrollToTop />
        
        <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Aviso legal</h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Datos identificativos</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad 
                de la Información y Comercio Electrónico, se informa a los usuarios de los datos identificativos 
                del titular del sitio web:
              </p>
              <ul className="list-none text-gray-600 space-y-2">
                <li><strong>Denominación social:</strong> Vaciado de Pisos Barcelona (VPB)</li>
                <li><strong>Domicilio:</strong> Barcelona y área metropolitana</li>
                <li><strong>Email:</strong> info@vaciadopisosbarcelona.com.es</li>
                <li><strong>Teléfono:</strong> 629 501 941</li>
                <li><strong>Sitio web:</strong> vaciadopisosbarcelona.com.es</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Objeto</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                El presente aviso legal regula el uso y utilización del sitio web vaciadopisosbarcelona.com.es, 
                del que es titular VPB. La navegación por el sitio web atribuye la condición de usuario del mismo 
                e implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas en 
                este aviso legal. Para más información sobre el tratamiento de datos personales, consulta nuestra <a href="/politica-privacidad" className="text-teal-600 hover:text-teal-700 underline cursor-pointer">política de privacidad</a>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Condiciones de uso</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                El acceso y uso de este sitio web se rige por las condiciones legales que se detallan a continuación. 
                El usuario se compromete a utilizar el sitio web, sus servicios y contenidos de conformidad con la ley, 
                el presente aviso legal, las buenas costumbres y el orden público.
              </p>
              <p className="text-gray-600 leading-relaxed mb-4">
                Queda prohibido el uso del sitio web con fines ilícitos o lesivos contra VPB o cualquier tercero, 
                o que de cualquier forma puedan dañar, inutilizar, sobrecargar o deteriorar el sitio web o impedir 
                su normal utilización por parte de otros usuarios. Consulta nuestra <a href="/politica-cookies" className="text-teal-600 hover:text-teal-700 underline cursor-pointer">política de cookies</a> para conocer cómo utilizamos las cookies en este sitio.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Propiedad intelectual e industrial</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Todos los contenidos del sitio web, incluyendo, sin carácter limitativo, textos, fotografías, 
                gráficos, imágenes, iconos, tecnología, software, links y demás contenidos audiovisuales o sonoros, 
                así como su diseño gráfico y códigos fuente, son propiedad intelectual de VPB o de terceros, 
                sin que puedan entenderse cedidos al usuario ninguno de los derechos de explotación reconocidos 
                por la normativa vigente en materia de propiedad intelectual sobre los mismos.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Responsabilidad</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                VPB no se hace responsable de los daños y perjuicios de cualquier naturaleza que pudieran derivarse 
                de la falta de disponibilidad o de continuidad del funcionamiento del sitio web, de la defraudación 
                de la utilidad que los usuarios hubieren podido atribuir al sitio web, ni de la falibilidad del sitio web.
              </p>
              <p className="text-gray-600 leading-relaxed mb-4">
                VPB excluye cualquier responsabilidad por los daños y perjuicios de cualquier naturaleza que pudieran 
                deberse a la presencia de virus o a la presencia de otros elementos lesivos en los contenidos que 
                puedan producir alteraciones en el sistema informático, documentos electrónicos o ficheros de los usuarios.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Enlaces externos</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                El sitio web puede contener enlaces a otros sitios web de terceros. VPB no asume ninguna 
                responsabilidad por el contenido, políticas de privacidad o prácticas de sitios web de terceros. 
                El usuario reconoce y acepta que VPB no será responsable, directa o indirectamente, de ningún daño 
                o pérdida causados o presuntamente causados por o en conexión con el uso de cualquier contenido, 
                bienes o servicios disponibles en dichos sitios web.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Modificaciones</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                VPB se reserva el derecho de efectuar sin previo aviso las modificaciones que considere oportunas 
                en su sitio web, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se presten 
                a través de la misma como la forma en la que éstos aparezcan presentados o localizados.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Legislación aplicable y jurisdicción</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Las presentes condiciones generales se rigen por la legislación española. Para la resolución de 
                cualquier controversia que pudiera surgir en relación con el sitio web o las actividades en él 
                desarrolladas, serán competentes los Juzgados y Tribunales de Barcelona, renunciando expresamente 
                las partes a cualquier otro fuero que pudiera corresponderles.
              </p>
            </section>

            <div className="mt-12 p-6 bg-gray-50 rounded-xl">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">¿Necesitas más información?</h3>
              <p className="text-gray-600 mb-4">
                Si tienes alguna duda sobre nuestros términos legales o necesitas información sobre nuestros <a href="/#servicios" className="text-teal-600 hover:text-teal-700 font-semibold underline cursor-pointer">servicios de vaciado de pisos</a>, no dudes en <a href="/#contacto" className="text-teal-600 hover:text-teal-700 font-semibold underline cursor-pointer">contactarnos</a>.
              </p>
            </div>

            <p className="text-sm text-gray-500 mt-8">
              Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}
